export const SERVERS_PATH = '/servers';
export const SERVER_DETAILS_PATH = `${SERVERS_PATH}/:serverId`;

export const CONFIGS_PATH = '/configs';
export const CONFIGS_HISTORY_PATH = `${CONFIGS_PATH}/history`;
export const CONFIGS_COMPARE_PATH = `${CONFIGS_PATH}/compare`;

export const SCHEMAS_PATH = '/schemas';

export const DEPLOYMENTS_PATH = '/deployments';
export const DEPLOYMENTS_VIEW_PATH = `${DEPLOYMENTS_PATH}/view`;
export const DEPLOYMENTS_CREATE_PATH = `${DEPLOYMENTS_PATH}/create`;
